// Function to get value from localStorage or fall back to env variable
const getConfigValue = (localStorageKey: string, envValue: string | undefined, defaultValue: string): string => {
  // Check localStorage first
  const localStorageValue = localStorage.getItem(localStorageKey);
  if (localStorageValue) return localStorageValue;
  
  // Then check environment variable
  if (envValue) return envValue;
  
  // Finally use default
  return defaultValue;
};

// Get environment variables
const env = {
  DATA_API_URL: process.env.REACT_APP_DATA_API_URL,
  CAM_API_URL: process.env.REACT_APP_CAM_API_URL,
  CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
  TOKEN: process.env.REACT_APP_CAM_API_KEY
};

// Export with localStorage preference over env variables
export const DATA_API_URL = getConfigValue('dataApiUrl', env.DATA_API_URL, 'http://localhost:8000');
export const CAM_API_URL = getConfigValue('camApiUrl', env.CAM_API_URL, 'http://localhost:8080');
export const CLIENT_ID = env.CLIENT_ID || 'default_client_id'; 
export const TOKEN = getConfigValue('camApiKey', env.TOKEN, 'default_token');